import { HelpDocsService } from '@mode/shared/util-js';
import * as angular from 'angular';

class IdentityScimFormController {
  public isCollapsed = false;
  private baseUrl: string;
  private bearerToken: string;
  private boolean: boolean;
  public onProvisionToggled: () => void;

  static $inject = ['HelpDocsService'];

  constructor(public helpDocs: HelpDocsService) {}

  userProvisioningToggleClicked() {
    this.onProvisionToggled();
  }

  handleToggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
  }
}

export const IdentityScimFormComponent: angular.IComponentOptions = {
  controller: IdentityScimFormController,
  controllerAs: 'ctrl',
  bindings: {
    baseUrl: '<',
    bearerToken: '<',
    scimProvisionEnabled: '<',
    onProvisionToggled: '&',
  },
  template: `
    <div class="identity-scim-form-container" ng-class="{'collapsed': ctrl.isCollapsed }">
      <div class="show-configuration-labels" ng-click="ctrl.handleToggleCollapsed()">
        <span>{{ ctrl.isCollapsed ? 'VIEW' : 'HIDE' }} CONFIGURATION</span>
        <span ng-class="{'collapsed': ctrl.isCollapsed, 'icon-caret-down': true }"></span>
      </div>

      <form>
        <div class="form-section">
          <h4>Provider URL</h4>
          <p class="description">
            Choose the Base URL link for your specific identity provider (the URL name may vary).
            <a
              href="{{ ctrl.helpDocs.links['https://mode.com/help/articles/authentication-and-sso/#scim'] }}"
              target="_blank"
            >Learn more</a>
          </p>

          <div class="form-group tenant">
            <label for="base_url">Azure Active Directory Tenant URL</label>
            <copy-to-clipboard-field
              input-content="ctrl.baseUrl + '?aadOptscim062020'"
              input-is-enabled="false"
            />
          </div>

          <div class="form-group okta">
            <label for="base_url">Okta Base URL</label>
            <copy-to-clipboard-field
              input-content="ctrl.baseUrl"
              input-is-enabled="false"
            />
          </div>

          <div class="form-group token">
            <label for="scim_api_token">SCIM API token</label>
            <copy-to-clipboard-field
              input-content="ctrl.bearerToken"
              input-is-enabled="false"
              input-is-password="true"
            />
          </div>

          <div class="form-group inline">
            <label for="scim_provision_limit">
              <span class="label-heading">Only use SCIM for user provisioning</span>
              <p class="label-content">This will disable all other methods for creating users in Mode.</p>
            </label>
            <checkbox-toggle
              ng-click="ctrl.userProvisioningToggleClicked()"
              checked="ctrl.scimProvisionEnabled"
            />
          </div>
        </div>
      </form>
    </div>
  `,
};
